import { useMutation } from '@apollo/client'
import { ArchiveProcessDocument, GetProcessesDocument } from 'generated/resources/graphql'

export const useArchiveProcess = () => {
  const [executeMutation] = useMutation(ArchiveProcessDocument)

  const archiveProcess = async (id: string) => {
    const { data, errors } = await executeMutation({
      variables: {
        id,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetProcessesDocument,
          variables: {
            ids: [id],
          },
        },
      ],
    })

    if (errors?.length || data?.processesMutations?.archiveProcessesProcess?.errors.length) {
      throw (
        'Could not archive process: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.archiveProcessesProcess?.errors || []),
        ])
      )
    }
  }

  return {
    archiveProcess,
  }
}
